import React, { Component } from "react";
import { Link } from "react-router-dom";

const posttitle = "our Recent news";
const abouttitle = "About Tegal";
const aboutpara =
  "Tegal is a premier matchmaking platform designed to connect individuals seeking meaningful, long-term relationships leading to marriage. Our mission is to provide a trusted, secure, and personalized experience for our users.";
const newstitle = "Signup to our Newsletter";
const newspara =
  "By subscribing to our mailing list you will always be upto date on what's going here.";

let RecentPostList = [
  {
    imgUrl: "assets/images/footer/01.jpg",
    imgAlt: "recent post",
    postTitle: "Woman Finally Finds Solace on Tegal",
    postDate: "July 03, 2024",
  },
  {
    imgUrl: "assets/images/footer/02.jpg",
    imgAlt: "recent post",
    postTitle: "Tegal Set to Break Match-Making Records Soon",
    postDate: "June 23, 2024",
  },
  {
    imgUrl: "assets/images/footer/03.jpg",
    imgAlt: "recent post",
    postTitle: "Love is in the Air!",
    postDate: "May 18, 2024",
  },
];

class FooterSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newsEmail: "",
    };
  }
  render() {
    return (
      <footer className="footer-section">
        <div className="footer-top">
          <div className="container">
            <div className="row g-3 justify-content-center g-lg-0">
              <div className="col-lg-6 col-sm-6 col-12">
                <div className="footer-top-item lab-item">
                  <div className="lab-inner">
                    <div className="lab-thumb">
                      <img
                        src="assets/images/footer/icons/02.png"
                        alt="email-icon"
                      />
                    </div>
                    <div className="lab-content">
                      <span>hello@tegalapp.com</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-sm-6 col-12">
                <div className="footer-top-item lab-item">
                  <div className="lab-inner">
                    <div className="lab-thumb">
                      <img
                        src="assets/images/footer/icons/03.png"
                        alt="location-icon"
                      />
                    </div>
                    <div className="lab-content">
                      <span>Ihesiaba Court, Ishaya Shekari Crescent, Federal Staff Housing Estate, Gwarinpa, Abuja, FCT Nigeria</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="footer-middle padding-tb"
          style={{ backgroundImage: "url(/assets/images/footer/bg.png)" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="footer-middle-item-wrapper">
                  <div className="footer-middle-item mb-lg-0">
                    <div className="fm-item-title">
                      <h4>{abouttitle}</h4>
                    </div>
                    <div className="fm-item-content">
                      <p className="mb-4">{aboutpara}</p>
                    </div>

                    <div className="mt-5">
                      <h3>Our Policies</h3>
                      <ul>
                        <li className="mb-2">
                          <Link to="/privacy-policy">Privacy Policy</Link>
                        </li>
                        <li className="mb-2">
                          <Link to="/data-protection-policy">
                            Data Protection Policy
                          </Link>
                        </li>
                        <li className="mb-2">
                          <Link to="/terms-conditions">
                            Terms and Conditions
                          </Link>
                        </li>
                        <li className="mb-2">
                          <Link to="/csae">
                            Tegal's CSAE
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="footer-middle-item-wrapper">
                  <div className="footer-middle-item mb-lg-0">
                    <div className="fm-item-title">
                      <h4>{posttitle}</h4>
                    </div>
                    <div className="fm-item-content">
                      {RecentPostList.map((val, i) => (
                        <div className="fm-item-widget lab-item" key={i}>
                          <div className="lab-inner">
                            <div className="lab-content">
                              <h6>
                                {val.postTitle}
                                {/* <Link to="/blog-single"></Link> */}
                              </h6>
                              <p>{val.postDate}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="footer-middle-item-wrapper">
                  <div className="footer-middle-item-3 mb-lg-0">
                    <div className="fm-item-title">
                      <h4>Tegal Account</h4>
                    </div>
                    <div className="fm-item-content">
                      <ul>
                        <li className="mb-2">
                          <a href="https://play.google.com/store/apps/details?id=com.syrol.tegal">Create Account</a>
                        </li>
                        <li className="mb-2">
                          <Link to="/deletion">
                            Delete Account
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer-bottom-content text-center">
                  <p>
                    &copy; 2024{" "}
                    <Link to="https://tegalapp.com">
                      Tegal, All Rights Reserved
                    </Link>{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default FooterSection;
